<template>
    <div style="width: 100vw" v-if="data">
      <v-chart class="chart" :option="options" autoresize />
    </div>
  </template>
    
  <script>
  import { use } from 'echarts/core';
  import { CanvasRenderer } from 'echarts/renderers';
  import { HeatmapChart } from 'echarts/charts';
  import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
  } from 'echarts/components';
  import VChart from 'vue-echarts';
  
  use([
    CanvasRenderer,
    HeatmapChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
  ]);
  
  export default {
    props: ["data", "xLabels", "yLabels"],
    data() {
        return {
            // data: null,
            // xLabels: null,
            // yLabels: null,
        }
    },
    name: 'ChartArea',
    components: {
      VChart,
    },
    computed: {
        options: function() {
            console.log("options are changing")
            return {
                tooltip: {
                    position: 'top'
                },
                grid: {
                    height: '70%',
                    top: '0%',
                    // containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    data: [],
                    splitArea: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'category',
                    data: [],
                    splitArea: {
                        show: false
                    }
                },
                visualMap: {
                    min: 0,
                    max: 100,
                    calculable: true,
                    orient: 'horizontal',
                    left: 'center',
                    bottom: '15%',
                    inRange: {
                    color: [
                        'red',
                        'yellow',
                        'green',
                    ]
                    }
                },
                series: [{
                    name: '',
                    type: 'heatmap',
                    data: this.data,
                    label: {
                    show: true,
                    formatter: function(d) {
                        return d.name.slice(0,4)
                    },
                    },
                    emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                    }
                }]
            }
        },
    },
  }
  
  </script>
    
  <style scoped>
  .chart {
    height: 40vh;
  }
  </style>
    

